import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  Typography,
  Box,
  Link,
  Tabs,
  makeStyles,
  Tab,
  Dialog,
  CircularProgress,
} from "@material-ui/core";
import { Save, ArrowBack, ArrowForward } from "@material-ui/icons";
import StyledButton from "../../../../common/models/Button";
import ReasonCodeUploader from "./CreateNewResonCode";
// import {
//   DESTROY_BACKDROP,
//   OPEN_BACKDROP,
// } from "../../../containers/actions/types";

import { useDispatch } from "react-redux";
import { appUrl } from "../../../../../utils/config";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "100%",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f9f9f9",
    padding: "12px 16px",
    borderBottom: "1px solid #ccc",
    textAlign: "left",
  },
  bodyCell: {
    padding: "12px 16px",
    borderBottom: "1px solid #eee",
    textAlign: "left",
    verticalAlign: "middle",
    color: "#333",
    fontSize: "14px",
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#333",
    borderRadius: "20px",
    padding: "8px 20px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #333",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(4),
  },
  backButton: {
    backgroundColor: "#555",
    color: "#fff",
    borderRadius: "20px",
    padding: "10px 28px",
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#333",
    },
  },
  radioGroupContainer: {
    backgroundColor: "#eaf6fb",
    borderRadius: "4px",
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
  },
  radioLabel: {
    fontWeight: 600,
    marginRight: theme.spacing(2),
    fontSize: "14px",
  },
  radioGroup: {
    display: "flex",
    alignItems: "center",
  },
  // formControlLabel: {
  //   marginRight: theme.spacing(3),
  //   "& .MuiTypography-body1": {
  //     fontSize: "14px",
  //   },
  // },
  orangeRadio: {
    color: "#f26522",
    "&.Mui-checked": {
      color: "#f26522",
    },
  },
  saveButton: {
    backgroundColor: "#f26522",
    color: "#fff",
    borderRadius: "20px",
    padding: "10px 28px",
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#d4551a",
    },
  },

  tabRoot: {
    borderBottom: "1px solid #ccc",
  },
  tabIndicator: {
    backgroundColor: "#007bff",
  },
  radioGroup: {
    //backgroundColor: "#f6f6f6",
    borderRadius: "4px",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  link: {
    fontWeight: 600,
  },
}));

const ReasonCodeGroupTab = (props) => {
  const { featuresAccess } = props;
  const [selectedOption, setSelectedOption] = useState("sponsor");
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(1); // Start with Sponsor Reason Codes selected
  const [uploadDialog, setUploadDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  
  // Get edit access from featuresAccess
  const canEdit = featuresAccess?.editSponsorNetworkDetails ?? false;
  
  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
      // Open backdrop logic would go here
    } else if (action.type === "DESTROY_BACKDROP") {
      // Close backdrop logic would go here
    }
  };
  //const [reasonCodes, setReasonCodes] = useState([]);
  const [reasonCodes, setReasonCodes] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [lastSyncTime, setLastSyncTime] = useState(new Date());
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [error, setError] = useState(null); // Added error state
  const [filters, setFilters] = useState({
    searchBy: "",
    searchTerm: "",
    reasonCodeType: "all",
    reasonCodeGroupType: "all",
    status: "all",
  });

  const handleOpen = () => {
    setUploadDialog(true);
  };

  const handleClose = () => {
    setUploadDialog(false);
    if (uploadSuccess) {
      setUploadSuccess(false); // Reset upload success state
      fetchReasonCodes();
    }
  };
  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Sample data for the table
  // const reasonCodes = [
  //   {
  //     codeGroup: "External Manufacturing Receipt To Promise",
  //     codeGroupType: "Default",
  //     reasonCode: "EXMRP001",
  //     description: "Tolled Material Delay/Constraint",
  //     reasonCodeType: "Default",
  //     visibleTo: "BMS",
  //   },
  //   {
  //     codeGroup: "External Manufacturing Receipt To Promise",
  //     codeGroupType: "Default",
  //     reasonCode: "EXMRP002",
  //     description: "Vendor Quality Event/Investigation",
  //     reasonCodeType: "Default",
  //     visibleTo: "CMO",
  //   },

  //   {
  //     codeGroup: "External Manufacturing Receipt To Promise",
  //     codeGroupType: "Default",
  //     reasonCode: "EXMRP019",
  //     description: "Other Not Vendor Related",
  //     reasonCodeType: "Default",
  //     visibleTo: "BMS",
  //   },
  // ];
  const OPEN_BACKDROP = "OPEN_BACKDROP";
  const DESTROY_BACKDROP = "DESTROY_BACKDROP";

  const fetchReasonCodes = async (updatedFilters = filters) => {
    setLoading(true);
    setError(null); // Reset error state before new fetch

    // Open backdrop before API call
    dispatch({
      type: OPEN_BACKDROP,
    });

    try {
      const requestObject = {
        searchField: updatedFilters.searchBy || "all",
        searchValue: updatedFilters.searchTerm || "",
        reasonCodeGroupType: updatedFilters.reasonCodeGroupType || "all",
        reasonCodeType: updatedFilters.reasonCodeType || "all",
        status: updatedFilters.status || "all",
        collaboratorTypeID: "all",
      };

      const url = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchReasonCodes`;

      const response = await axios.post(url, requestObject);
      //console.log("response", response);
      if (response.data.status) {
        const result = response.data.data.reasonCodeList || [];
        setReasonCodes(result);
        setFilteredData(result);
        setLastSyncTime(new Date());
  //        if (props.setReasonCodesData) {
  //   props.setReasonCodesData(result); // <-- This updates the parent state
  // }
      // props.setReasonCodesData((prev) => !prev);
      }
      
 
      // Close backdrop after successful response
      dispatch({
        type: DESTROY_BACKDROP,
      });
    } catch (error) {
      setError("Something went wrong. Please try again.");

      // Close backdrop on error
      dispatch({
        type: DESTROY_BACKDROP,
      });
    } finally {
      setLoading(false);
      setUploadSuccess(false);
    }
  };

  // On component mount, fetch data
  useEffect(() => {
    fetchReasonCodes();
  }, []);

  return (
    <div className="flex flex-col w-full">
      {/* Tabs */}
      {/* <Tabs
        value={tabValue}
        onChange={handleTabChange}
        classes={{ root: classes.tabRoot, indicator: classes.tabIndicator }}
        textColor="primary"
      >
        <Tab label="Moasymphony Reason Codes" value={0} />
        <Tab label="Sponsor Reason Codes" value={1} />
      </Tabs> */}

      {/* Radio Button Selection */}
      <Box className={classes.radioGroupContainer}>
        <Typography className={classes.radioLabel}>
          Select Reason Codes List:
        </Typography>
        <RadioGroup
          row
          value={selectedOption}
          onChange={handleOptionChange}
          //className={classes.radioGroup}
        >
          <FormControlLabel
            value="mosynmphony"
            control={<Radio className={classes.orangeRadio} disabled />}
            label="Use Mosymphony Reason Codes"
            className={classes.formControlLabel}
          />
          <FormControlLabel
            value="sponsor"
            control={<Radio className={classes.orangeRadio} />}
            label="Use Sponsor Reason Codes"
            className={classes.formControlLabel}
          />
        </RadioGroup>
      </Box>

      {/* Recent Uploaded File Section */}
      {/* <Box className="mb-4" style={{ marginTop: "1rem" }}>
        <Typography variant="subtitle1" className="font-medium">
          View Recent Uploaded File
        </Typography>
        <Link
          href="#"
          color="#1976d2"
          className={classes.link}
          style={{ cursor: "not-allowed" }}
        >
          BMS reason code.xlsx
        </Link>
      </Box> */}

      {/* Upload Button */}
      {canEdit && (
        <div style={{ marginBottom: "1rem" }}>
          <Button
            variant="outlined"
            onClick={handleOpen}
            className={classes.addButton}
          >
            <span className={classes.addIconCircle}>+</span>
            Upload Sponsor Reason Codes
          </Button>
          <Dialog
            fullScreen
            open={uploadDialog}
            onClose={handleClose}
            // TransitionComponent={Transition} // Define this or use Slide/Zoom as fallback
          >
            <ReasonCodeUploader
              handleClose={handleClose}
              fetchReasonCodes={fetchReasonCodes}
              //vendorData={vendorData}
              onUploadSuccess={() => setUploadSuccess(true)}
              setReasonCodesData = {props.setReasonCodesData} // Pass the function to update parent state
            />
          </Dialog>
        </div>
      )}

      {/* Table */}
      <TableContainer component={Paper} className="mb-4">
        <Table className={`${classes.table} default-table-styles`}>
          <TableHead>
            <TableRow>
              <TableCell className={`${classes.headerCell} default-table-styles`}>Code Group</TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>
                Code Group Type
              </TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>Reason Code</TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>
                Reason Code Description
              </TableCell>
              <TableCell className={`${classes.headerCell} default-table-styles`}>
                Reason Code Type
              </TableCell>
              <TableCell className={classes.headerCell}>
                Visible To Organization
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100px",
                    }}
                  >
                    <CircularProgress />
                  </div>
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={6}
                   align="center"
    style={{
      background: "#ffecec",
      color: "#b00020",
      border: "1px solid #ff9999",
      fontWeight: 600,
      fontSize: "16px",
      textAlign: "center",
      height: "64px",
      letterSpacing: "0.5px",
    }}
         >
                     <Typography>{error}</Typography>
                 
                </TableCell>
              </TableRow>
            ) : reasonCodes.length === 0 ? (
              // Show "No Data" message when batchStatuses is empty
              <TableRow>
                <TableCell colSpan={4}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "60px",
                      width: "100%",
                      color: "#666",
                    }}
                  >
                    <Typography>No ReasonCodes Found</Typography>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              reasonCodes.map((row) => (
                <TableRow key={row.reasonCode}>
                  <TableCell className={classes.bodyCell}>
                    {row.reasonCodeGroup}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row.reasonCodeGroupType}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row.reasonCode}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row.reasonDescription}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row.reasonCodeType}
                  </TableCell>
                  <TableCell className={classes.bodyCell}>
                    {row.Visibletoorg}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Navigation Buttons */}
      {/* <div className={classes.footer}>
        <Button
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          &lt; Back
        </Button>
        <StyledButton
          className={classes.saveButton}
          onClick={() => {
            props.handleNext(); // Directly move to the next tab if no updates are made
          }}
        >
          Save & Next
        </StyledButton>
      </div> */}
    </div>
  );
};

export default ReasonCodeGroupTab;
